import { render } from "./QueueNumber.vue?vue&type=template&id=50631427&scoped=true"
import script from "./QueueNumber.vue?vue&type=script&lang=js"
export * from "./QueueNumber.vue?vue&type=script&lang=js"

import "./QueueNumber.vue?vue&type=style&index=0&id=50631427&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50631427"]])

export default __exports__